"use strict";
// @ts-ignore
try {
    self['workbox:precaching:7.0.0'] && _();
}
catch (e) { }
